var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Particles',{staticStyle:{"height":"100%","width":"100%","position":"absolute","overflow":"hidden","z-index":"2","max-height":"100%"},attrs:{"id":"tsparticles","particlesInit":_vm.particlesInit,"particlesLoaded":_vm.particlesLoaded,"options":_vm.particleOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }